import React from 'react';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';

const RoleNotes = {
  analyst:
    (<>
      Assigning this role will incur an{' '}
      <ExternalLink
        data-aid="additional-cost-help-link"
        label="additional cost"
        to="https://help.gladly.com/implementation/docs/invoice-and-billing-overview#types-of-users"
      />
      .
    </>),
};

export default RoleNotes;